import _round from "lodash/round";
import _size from "lodash/size";
import { CART_ITEM_TYPE, REALM } from "../../../../../constants";
import { ICartItem, ICartItemOther, ICartItemSubscription } from "../../../../../models";
import { BusinessProduct, OfferingB2B } from "../../../../../models/state";
import { GaProductsState } from "../../../google-analytics/state/selectors";

export const getStateForGAFromManualOrder = (
    selectedSubscriptions: OfferingB2B[],
    ids: number[],
    product: Partial<BusinessProduct>,
    orderId?: string,
): GaProductsState => {
    const subscriptions: Record<string, any> = {}; // change when TS for GA is added
    const content: ICartItem[] = [];

    for (let index = 0; index < _size(selectedSubscriptions); index++) {
        const selectedSubscription = selectedSubscriptions[index];
        // TODO: abort when price is undefined?
        if (typeof selectedSubscription.monthlyPrice === "undefined") continue;
        const subscription = {
            id: ids[index],
            code: selectedSubscription.offeringCode,
            name: selectedSubscription.name,
            price: {
                monthly: {
                    amountSubscription: _round(selectedSubscription.monthlyPrice * 1.25, 2),
                },
            },
            size: selectedSubscription.size,
            isDataUnlimited: selectedSubscription.isDataUnlimited,
        };

        const cartSubscription: ICartItemSubscription = {
            type: CART_ITEM_TYPE.SUBSCRIPTION,
            id: `${selectedSubscription.offeringCode}`,
            bundleId: `${ids[index]}`,
            name: selectedSubscription.name,
            quantity: {
                value: 1,
            },
            price: {
                monthly: _round(selectedSubscription.monthlyPrice * 1.25, 2),
            },
            status: {
                isActive: true,
                isDraft: false,
            },
        };

        subscriptions[ids[index]] = subscription;
        content.push(cartSubscription);
    }

    if (product && product.sku && product.type) {
        const hardwareItem: ICartItemOther = {
            type: product.type,
            id: product.sku,
            bundleId: `${ids[0]}`,
            brand: product.brand,
            model: `${product.model}`,
            color: product.color,
            name: `${product.name}`,
            quantity: {
                value: 1,
            },
            price: {},
        };

        // Add SVITSJ price to hw and sub
        if (product.type === CART_ITEM_TYPE.HANDSET && product.salesPriceWithoutVat) {
            hardwareItem.price = {
                monthly: _round(product.salesPriceWithoutVat * 1.25, 2),
            };
            subscriptions[ids[0]].financing = {
                type: "switch",
                code: "SWITCH_FLEX_TF_B2B",
                duration: "24",
            };
        } else if (product.type === CART_ITEM_TYPE.MODEM && product.salesPriceWithoutVat) {
            hardwareItem.price = {
                upfront: _round(product.salesPriceWithoutVat * 1.25, 2),
            };
        }

        content.push(hardwareItem);
    }

    return {
        general: {
            announcements: [],
            realm: REALM.B2B,
            orderId,
        },
        checkout: {
            subscriptions,
            cart: {
                content,
            },
        },
    };
};
